import React, { useState, useEffect } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { columns, rows } from '../internals/data/batteryData';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

function randomArray(length, min, max) {
  const randomArray = [];
  for (let i = 0; i < length; i++) {
    randomArray.push(Math.floor(Math.random() * (max
      - min + 1)) + min);
  }
  return randomArray;
}

function generateExportFileName() {
  return "Battery-packs-" + dayjs().format('YYYY-MM-DD HH:mm:ss');
}

export default function BatteryDataGrid() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://0h5n8j55d5.execute-api.ap-south-1.amazonaws.com/dev/battery-packs/');
        const batteryPacksResponse = await response.json();
        const batteryPacksData = [];
        batteryPacksResponse.forEach((battery, index) => {
          const batteryPackData = { id: index, assignedTo: 'IGT', packetHistory: randomArray(25, 0, 100) };
          Object.keys(battery).forEach(key => {
            switch (key) {
              case 'id':
                batteryPackData['packID'] = battery[key];
                break;
              case 'IMEI':
                batteryPackData['imei'] = battery[key];
                break;
              case 'isActive':
                batteryPackData['status'] = battery[key] ? 'Online' : 'Offline';
                break;
              case 'model_bms':
                batteryPackData['model_bms'] = battery[key].toUpperCase();
                break;
              default:
                batteryPackData[key] = battery[key];
            }
          });
          // Redundency Filter
          if (batteryPacksData.find(obj => obj['imei'] === batteryPackData['imei'] && obj['packID'] === batteryPackData['packID']) === undefined)
            batteryPacksData.push(batteryPackData);
        });
        setData(batteryPacksData);
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, []);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const handleCellClick = (params) => {
    // console.log('Cell clicked:', params);
    navigate(`/battery-packs/${params.row.imei}`);
  };

  return (
    <DataGrid
      autoHeight
      checkboxSelection
      rows={data}
      columns={columns}
      getRowClassName={(params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
      }
      initialState={{
        pagination: { paginationModel: { pageSize: 20 } },
      }}
      pageSizeOptions={[10, 20, 50]}
      onCellClick={handleCellClick}
      disableColumnResize
      density="compact"
      slots={{ toolbar: GridToolbar }}
      slotProps={{
        toolbar: {
          showQuickFilter: true,
        },
        csvOptions: { fileName: generateExportFileName() },
        printOptions: { fileName: generateExportFileName(), hideToolbar: true, },
        filterPanel: {
          filterFormProps: {
            logicOperatorInputProps: {
              variant: 'outlined',
              size: 'small',
            },
            columnInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            operatorInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            valueInputProps: {
              InputComponentProps: {
                variant: 'outlined',
                size: 'small',
              },
            },
          },
        },
      }}
    />
  );
}
